import HomeBrokenIcon from '../../assets/images/solar/home/HomeBroken';
import { COLORS } from '../../config/designSystem/Colors';
import { FC } from 'react';
import { Feather } from '@expo/vector-icons';
import { SolarBubbleChatBoldIcon } from '../../assets/images/solar/bubble-chat/BubbleChatBold';
import { SolarBubbleChatIcon } from '../../assets/images/solar/bubble-chat/BubbleChat';
import { SolarHomeIcon } from '../../assets/images/solar/home/HomeSmile';
import { SolarMagnifierBoldIcon } from '../../assets/images/solar/magnifier/MagnifierBold';
import { SolarMagnifierIcon } from '../../assets/images/solar/magnifier/Magnifier';
import { SolarUserBoldIcon } from '../../assets/images/solar/user/UserBold';
import { SolarUserIcon } from '../../assets/images/solar/user/User';
import { assistanceStackKey, dashboardStackKey, libraryStackKey, healthStackKey as profileStackKey, settingStackKey } from '../../constants/routeKeys';
import { useIsSmallWeb } from '../../hooks/ui/useIsSmallWeb';



interface NavigationPanelTabElementProp {
    labelKey: string,
    selected: boolean,
    size?: number
  }

export const NavigationIcon: FC<NavigationPanelTabElementProp> = ({labelKey, selected, size}) => {
  const SIZE= size? size: 24;

  const {hasLateralBar} = useIsSmallWeb();

  if(!selected) {
    switch (labelKey) {
    case dashboardStackKey:
      if(!hasLateralBar) {
        return <HomeBrokenIcon width={SIZE} height={SIZE} color={COLORS.content.tertiary}/>;
      } else {
        return <HomeBrokenIcon width={SIZE} height={SIZE} color={COLORS.brand['400']}/>;
      }
    case libraryStackKey:
      if(!hasLateralBar) {
        return <SolarMagnifierIcon size={SIZE} color={COLORS.content.tertiary} />;
      } else {
        return <SolarMagnifierIcon size={SIZE}/>;
      }
    case assistanceStackKey:
      if(!hasLateralBar) {
        return <SolarBubbleChatIcon size={SIZE} color={COLORS.content.tertiary} />;
      } else {
        return <SolarBubbleChatIcon size={SIZE}/>;
      }
    case profileStackKey:
      if(!hasLateralBar) {
        return <Feather name="heart" size={SIZE} color={COLORS.content.tertiary} />;
      } else {
        return <Feather name="heart" size={SIZE} color={COLORS.brand['400']} />;
      }
    case settingStackKey:
    default:
      if(!hasLateralBar) {
        return <SolarUserIcon size={SIZE} color={COLORS.content.tertiary} />;
      } else {
        return <SolarUserIcon size={SIZE}/>;
      }
    }

  } else {
    switch (labelKey) {
    case dashboardStackKey:
      if(!hasLateralBar) {
        return <SolarHomeIcon size={SIZE} color='white' fillColor={COLORS.content.accent}/>;

      } else {
        return <SolarHomeIcon size={SIZE} />;
      }
    case libraryStackKey:
      if(!hasLateralBar) {
        return <SolarMagnifierBoldIcon size={SIZE} color={COLORS.content.accent}/>;

      } else {
        return <SolarMagnifierBoldIcon size={SIZE} />;
      }
    case assistanceStackKey:
      if(!hasLateralBar) {
        return <SolarBubbleChatBoldIcon size={SIZE} color={COLORS.content.accent} secondColor={COLORS.content.accent}/>;

      } else {
        return <SolarBubbleChatBoldIcon size={SIZE} />;
      }
    case profileStackKey:
      if(!hasLateralBar) {
        return <Feather name="heart" size={SIZE} color={COLORS.content.accent} />;

      } else {
        return <Feather name="heart" size={SIZE} color="white" />;
      }
    case settingStackKey:
    default:
      if(!hasLateralBar) {
        return <SolarUserBoldIcon size={SIZE} color={COLORS.content.accent} />;

      } else {
        return <SolarUserBoldIcon size={SIZE} />;
      }
    }

  }

};




